import { Box, Typography } from '@mui/material'
import React from 'react'
import { WarningMessageProps } from './_props/WarningMessageProps'
import sx from './_styles/WarningMessageSxs'

const WarningMessage: React.FC<WarningMessageProps> = ({ message, align = 'flex-end' }) => (
    <Box
        sx={{
            ...sx.WarningMessage,
            justifyContent: align,
        }}
    >
        <Typography sx={sx.WarningMessageText}>{message}</Typography>
    </Box>
)

export default WarningMessage
